import { ApiService } from '../model/Api.model';
import { AxiosInstance } from 'axios';
import { ICourtFull } from '../interfaces/court/ICourtFull';
import { IFillSelect } from '../interfaces/generic/IFillSelect';

enum CourtServiceEnum {
	getAll = '/',
	getById = '/idCourt=',
	getCourtsByType = '/by-type?'
}

export default class CourtService extends ApiService {
	constructor(restClient: AxiosInstance) {
		super(restClient, '/court');
	}

	public getAll = async (): Promise<ICourtFull[]> => await this.GET(CourtServiceEnum.getAll);
	public getDetail = async (): Promise<ICourtFull> => await this.GET(CourtServiceEnum.getById);
	public getCourtsByType = async (idCourtType: number, onlyActive: boolean): Promise<IFillSelect[]> => await this.GET(CourtServiceEnum.getCourtsByType + `idCourtType=${idCourtType}&onlyActive=${onlyActive}`);
}



// WEBPACK FOOTER //
// ./src/services/api/Court.service.ts